export default {
    alert(msg, type = 'info') {
        if (type === 'success') {
            this.$noty.success(msg);
        } else if (type === 'warning') {
            this.$noty.warning(msg);
        } else if (type === 'error') {
            this.$noty.error(msg);
        } else {
            this.$noty.info(msg);
        }
    },

    getKeyByValue(object, value) {
        return Object.keys(object).find(key => object[key] === value);
    },

    getNextNumberedNames(name, technical_name, originalId, collection) {
        let lastChar = name[name.length - 1];
        let techName = technical_name;
        let lastCharTech = technical_name[technical_name.length - 1];
        if (!isNaN(lastChar)) {
            name = name.substring(0, name.length - 1);
        }
        if (!isNaN(lastCharTech)) {
            techName = techName.substring(0, techName.length - 1);
        }
        let nrOfDuplicates = 0;
        let firstElementId = originalId;
        for (let i = 0; i < collection.length; i++) {
            let mod = collection[i];
            if (mod.technical_name.indexOf(techName) !== -1) {
                let count = mod.technical_name.replace(techName, '');
                if(!isNaN(parseInt(count)) || count === ""){
                    nrOfDuplicates += 1;
                    if (i < firstElementId) {
                        firstElementId = i;
                    }
                }
            }
        }
        let newNr;
        if (nrOfDuplicates !== 0) {
            newNr = nrOfDuplicates + 1;
        } else {
            newNr = '';
            if (!isNaN(lastChar)) {
                name += lastChar;
            }
            if (!isNaN(lastCharTech)) {
                techName += lastCharTech;
            }
        }
        return {
            name: name + newNr,
            technical_name: techName + newNr,
            insertIndex: firstElementId + nrOfDuplicates
        }
    },
    getCurrentBreakpoint(){
        if (window.innerWidth >= 1200) {
            return 'lg';
        } else if (window.innerWidth >= 996) {
            return 'md';
        } else if (window.innerWidth >= 768) {
            return 'sm';
        } else if (window.innerWidth >= 480) {
            return 'xs';
        } else {
            return 'xxs';
        }
    },
    calcColWidth(){
        let colNum = 9;
        let width = window.innerWidth;
        if (this.getCurrentBreakpoint() === 'xs' || this.getCurrentBreakpoint() === 'xxs') {
            colNum = 3;
        } else if (this.getCurrentBreakpoint() === 'sm'|| this.getCurrentBreakpoint() === 'md' ) {
            colNum = 6;
        }else{
            width = width*0.84;
        }
        let colWidth = (width - (15 * (colNum + 1))) / colNum;
        colWidth = colWidth * 3 + 30;
        return colWidth;
    },
    toArray(string) {
        if(!Array.isArray(string)){
            return string.split(";").map(item => item.trim());
        }
        return string;
    },
};